window.$ = window.jQuery    = require('jquery');

const AjaxLoadPage = function()
{
	const _body                 = $('body');
	const _header               = $('#header');    
	const _introLayer           = $("#layerIntroPage");
	const _webdoorMotion 		= $("#webdoor");
	const _icoWhats 			= $("#ico-whats-float");
	const _loadElm 				= $("#loader-container");

	const pageLoader = function() {
		
		// setTimeout(() => {
			
			_body.removeClass('scroll-off body-content-loading');			
			_introLayer.addClass('motion-out');			
			_loadElm.fadeOut(300); 

			_introLayer.removeClass('motion-in '); 
			_webdoorMotion.addClass('motion-in '); 
			
			setTimeout(() => {
				_icoWhats.addClass("motion-in")
				_header.addClass('motion-in');
			},300)
			
			// SwiperGalleries.gallerySwiperWebdoor();
			// SwiperGalleries.galleryBasicSwiper();
		// },_timerSync)


	}

   
	return {
		init : function(status){

			pageLoader(status);			
			/* $('a[href]').not('.no-load').on('click',  (e) => {
			    e.preventDefault();
			    _introLayer.removeClass('motion-out');
			    // _introLayer.addClass('motion-in');
			    setTimeout(()=>{
			        window.location.href=e.currentTarget.getAttribute('href');
			    },1000)
			}); */

		}
	}

}();

export default  AjaxLoadPage;